
import { Component, Vue } from "vue-property-decorator";

import { InfoModel } from "@/models";
import { Cookie } from "@/util";

@Component<App>({
  components: {}
})
export default class App extends Vue {
  private time = 600000;
  private interval!: null | ReturnType<typeof setInterval>;

  public created() {
    this.$root.$on("setLogin", this.setLogin);
    this.$root.$on("setLogout", this.setLogout);
    window.addEventListener("beforeunload", this.actionBeforeLeave);

    const token = Cookie.getCookie("token");
    if (token !== null) {
      this.setLogin();
    }
  }

  public beforeDestroy() {
    this.setLogout();

    this.$root.$off("setLogin");
    this.$root.$off("setLogout");
  }

  private setLogin() {
    this.$data.interval = setInterval(() => {
      InfoModel.recordUserStayTime();
    }, this.$data.time);
  }

  private setLogout() {
    if (this.$data.interval) {
      clearInterval(this.$data.interval);
    }
  }

  private actionBeforeLeave() {
    this.$root.$emit("saveContact");
  }
}
